var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarSvgrepoCom4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 144.774 144.774",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF6726"
    },
    cx: 72.387,
    cy: 72.388,
    rx: 72.386,
    ry: 72.386
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 72.387,
    cy: 72.386,
    r: 72.386
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#10303F"
    },
    cx: 72.512,
    cy: 62.721,
    rx: 29.635,
    ry: 29.828
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M107.178,116.941c-4.666-8.833-34.666-14.376-34.666-14.376s-30,5.543-34.666,14.376 c-3.449,12.258-6.334,27.833-6.334,27.833h41h41C113.512,144.774,111.564,128.074,107.178,116.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.512,102.565c0,0,30,5.543,34.666,14.376c4.386,11.133,6.334,27.833,6.334,27.833h-41 V102.565z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.345,
    y: 84.607,
    style: {
      fill: "#F1C9A5"
    },
    width: 16.334,
    height: 27.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.512,
    y: 84.607,
    style: {
      fill: "#E4B692"
    },
    width: 8.167,
    height: 27.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C",
      enableBackground: "new"
    },
    d: "M64.345,97.274c1.469,4.217,7.397,6.634,11.751,6.634 c1.575,0,3.107-0.264,4.583-0.747V84.607H64.345V97.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M93.512,67.358c0-17.074-9.402-26.783-21-26.783s-21,9.709-21,26.783s9.402,30.917,21,30.917 C84.109,98.275,93.512,84.432,93.512,67.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M91.065,79.198c-3.807-0.392-6.377-4.429-5.732-9.012c0.637-4.586,4.242-7.991,8.051-7.601 c3.805,0.391,6.371,4.425,5.729,9.012C98.474,76.183,94.872,79.586,91.065,79.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M46.102,71.597c-0.643-4.587,1.924-8.621,5.727-9.012c3.811-0.391,7.416,3.015,8.055,7.601 c0.643,4.583-1.93,8.62-5.734,9.012C50.342,79.586,46.74,76.183,46.102,71.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M93.512,67.358c0-17.074-9.402-26.783-21-26.783v57.7 C84.109,98.275,93.512,84.432,93.512,67.358z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10303F"
    },
    d: "M73.719,35.349c-12.551,0-23.932,13.977-23.932,27.222c0,0.051,0.003,0.1,0.003,0.15h11.852 l1.122-8.839v8.839h12v-8.839l2.104,8.839h7.614v-7.339l1.826,7.339h8.924c0-0.051,0.003-0.1,0.003-0.15 C95.236,49.326,86.27,35.349,73.719,35.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10303F"
    },
    d: "M86.679,44.486c0,0,11.167-24.501,27.167-11.667s-11.418,52.364,12.916,49.864 c-8.666,9.167-20.416,4.137-21.416-16.03s-10.109-13-10.109-13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10303F"
    },
    d: "M58.617,44.486c0,0-11.167-24.501-27.167-11.667s10.896,51.614-13.438,49.114 C26.678,91.1,38.95,86.82,39.95,66.653s10.109-13,10.109-13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAE43E"
    },
    d: "M71.811,44.884c10.84,0,19.845,6.258,21.678,14.495c0.224-1.006,0.347-2.04,0.347-3.097 c0-9.715-9.86-17.592-22.024-17.592c-12.163,0-22.024,7.877-22.024,17.592c0,1.057,0.123,2.091,0.348,3.097 C51.967,51.142,60.971,44.884,71.811,44.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B10A"
    },
    d: "M107.178,116.941c-1.232-2.333-4.235-4.434-7.982-6.266c-5.871,1.085-15.63,1.796-26.684,1.796 s-20.812-0.711-26.684-1.796c-3.747,1.832-6.75,3.933-7.982,6.266c-3.449,12.258-6.334,27.833-6.334,27.833h41h41 C113.512,144.774,111.564,128.074,107.178,116.941z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarSvgrepoCom4);
export default __webpack_public_path__ + "static/media/avatar-svgrepo-com (4).5fb33fe00e23f8aa883958fe5a2398d9.svg";
export { ForwardRef as ReactComponent };